/* Maison Sohan — motion engine (vanilla, no deps) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal + stagger ---- */
  function initReveal() {
    var els = document.querySelectorAll('[data-ms-reveal],[data-ms-stagger]');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Auto-tag common sections for reveal ---- */
  function autoTag() {
    var sel = [
      '.multicolumn-list__item', '.collection .grid__item', '.featured-collection .grid__item',
      '.rich-text__blocks', '.image-with-text__content', '.banner__content',
      '.collapsible-content .accordion', '.contact', '.newsletter'
    ];
    document.querySelectorAll(sel.join(',')).forEach(function (el) {
      if (!el.hasAttribute('data-ms-reveal')) el.setAttribute('data-ms-reveal', '');
    });
    document.querySelectorAll('.multicolumn-list, .product-grid, .featured-collection .grid').forEach(function (el) {
      el.setAttribute('data-ms-stagger', '');
    });
  }

  /* ---- Count-up ---- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-ms-count]');
    if (!nums.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, target = parseFloat(el.getAttribute('data-ms-count')) || 0,
            dur = 1600, start = null,
            valEl = el.querySelector('.ms-val') || el;
        if (reduce) { valEl.textContent = target.toLocaleString('fr-FR'); io.unobserve(el); return; }
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1),
              eased = 1 - Math.pow(1 - p, 3),
              cur = target * eased;
          valEl.textContent = (target % 1 ? cur.toFixed(1) : Math.floor(cur)).toLocaleString('fr-FR');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Marquee: duplicate track for seamless loop ---- */
  function initMarquee() {
    document.querySelectorAll('.ms-marquee__track').forEach(function (track) {
      if (track.dataset.msCloned) return;
      track.dataset.msCloned = '1';
      track.innerHTML += track.innerHTML;
    });
  }

  /* ---- Header scrolled state ---- */
  function initHeader() {
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      document.body.classList.toggle('ms-header-scrolled', y > 40);
      last = y;
    }, { passive: true });
  }

  /* ---- Sticky mobile add-to-cart on product pages ---- */
  function initStickyATC() {
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    var main = document.querySelector('.product, .product__info-container');
    if (!form || !main) return;
    var titleEl = document.querySelector('.product__title h1, .product__title h2');
    var priceEl = document.querySelector('.price .price-item--regular, .price__regular .price-item');
    if (!titleEl) return;

    var bar = document.createElement('div');
    bar.className = 'ms-sticky-atc';
    bar.innerHTML =
      '<div class="ms-sticky-atc__info">' +
        '<div class="ms-sticky-atc__title">' + titleEl.textContent.trim() + '</div>' +
        '<div class="ms-sticky-atc__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</div>' +
      '</div>' +
      '<button type="button" class="ms-sticky-atc__btn">Ajouter</button>';
    document.body.appendChild(bar);

    bar.querySelector('.ms-sticky-atc__btn').addEventListener('click', function () {
      var realBtn = form.querySelector('[name="add"], button[type="submit"]');
      if (realBtn) realBtn.click();
    });

    var atcBtn = form.querySelector('[name="add"]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-show', !e.isIntersecting && window.innerWidth <= 749);
      });
    }, { threshold: 0 });
    if (atcBtn) io.observe(atcBtn);
  }

  /* ---- Light parallax on [data-ms-parallax] ---- */
  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-ms-parallax]');
    if (!items.length) return;
    window.addEventListener('scroll', function () {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect(),
            speed = parseFloat(el.getAttribute('data-ms-parallax')) || 0.15,
            offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
    }, { passive: true });
  }

  function boot() {
    autoTag();
    initReveal();
    initCounters();
    initMarquee();
    initHeader();
    initStickyATC();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  // Re-run in Shopify theme editor when sections reload
  document.addEventListener('shopify:section:load', function () {
    autoTag(); initReveal(); initCounters(); initMarquee();
  });
})();
